function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Task_Type:_Open",
  "data-name": "Task Type: Open",
  transform: "translate(-1072 -670)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_48",
  "data-name": "Ellipse 48",
  fill: "none",
  stroke: "currentColor",
  transform: "translate(1072 670)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "none",
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  cx: 12.5,
  cy: 12.5,
  r: 12
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_192",
  "data-name": "Path 192",
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M17236.871,678.389h9.824",
  transform: "translate(-16158.386)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_194",
  "data-name": "Path 194",
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M17236.871,678.389h7.887",
  transform: "translate(-16158.386 8)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_193",
  "data-name": "Path 193",
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M17236.867,678.389h13.266",
  transform: "translate(-16158.383 4)"
}));

var SvgOpenEndedQuestion = function SvgOpenEndedQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenEndedQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open-ended-question.8fdc1ec9.svg";
export { ForwardRef as ReactComponent };